export const colors = {
    brand: {
        50: "#E4FCFD",
        100: "#CAFBFD",
        200: "#96F0FB",
        300: "#61DBF3",
        400: "#3ABFE8",
        500: "#0098DA",
        600: "#0076BB",
        700: "#00589C",
        800: "#003E7E",
        900: "#002D68",
    },
    accent:{
        50: "#F4FCE8",
        100: "#EBFBD3",
        200: "#D4F8A9",
        300: "#B1EB7B",
        400: "#8DD858",
        500: "#5DBF28",
        600: "#44A41D",
        700: "#2E8914",
        800: "#1C6E0C",
        900: "#105B07",
    },
    green:{
        50: "#F2FEF4",
        100: "#DBFCE2",
        200: "#B8F9CD",
        300: "#91EFB9",
        400: "#72E0AB",
        500: "#47cc99",
        600: "#33AF8C",
        700: "#23927E",
        800: "#16766E",
        900: "#0D6061",
    },
    sidebar: '#122960',
    
    flat:{            
        tomato: "#FB4630",
        pink: "#FE445F",
        purple: "#773DE3",
        indigo: "#B28FF0",
        navy: "#3C50BC",
        blue: "#3389E1",
        aqua: "#00C3ED",
        teal: "#009988",
        green: "#77C33E",
        lime: "#A8E172",
        yellow: "#FFCC34",
        orange: "#FFB718",
        gray: "#616C78"
    },
    muted:{            
        tomato: "rgba(251,70,48, 0.25)",
        pink: "rgba(254,68,95, 0.25)",
        purple: "rgba(119,61,227, 0.25)",
        indigo: "rgba(178,141,240, 0.25)",
        navy: "rgba(60,80,188, 0.25)",
        blue: "rgba(51,137,225, 0.25)",
        aqua: "rgba(0,195,237, 0.25)",
        teal: "rgba(0,189,153, 0.25)",
        green: "rgba(119,195,62, 0.25)",
        lime: "rgba(168,225,114, 0.25)",
        yellow: "rgba(255,204,52, 0.25)",
        orange: "rgba(255,183,24, 0.25)",
        gray: "rgba(97,108,120, 0.25)",
    }      
}